import { render, staticRenderFns } from "./BillingMethodSave.vue?vue&type=template&id=00c95eeb"
import script from "./BillingMethodSave.vue?vue&type=script&lang=ts"
export * from "./BillingMethodSave.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports